// extracted by mini-css-extract-plugin
export default {"wrapper":"ReassignModal_wrapper__q4jF6","iconWrapper":"ReassignModal_iconWrapper__Pdj4O","heading":"ReassignModal_heading__H2U6P","footerBtn":"ReassignModal_footerBtn__Xp0QU"};